import { DataTablePagination, DataTableRow } from "../../types/data-table.types";
import * as T from "@shared/types";
import {
  PayoutActions,
  PayoutState,
  SetFetchingAction,
  SetInitializedAction,
  setInvoicesAction,
  setInvoicesStatsAction,
  SetLoadingAction,
  SetPaginationAction,
  SetParamsAction,
  SetSuccessAction,
} from "./types";

export function setPagination(pagination: DataTablePagination): SetPaginationAction {
  return {
    type: "SET_PAGINATION",
    payload: { pagination },
  };
}

export function setParams(params: T.InvoiceDetailsRequest): SetParamsAction {
  return {
    type: "SET_PARAMS",
    payload: { params },
  };
}

export function setInitialized(isInitialized: boolean): SetInitializedAction {
  return {
    type: "SET_INITIALIZED",
    payload: { isInitialized },
  };
}

export function setLoading(isLoading: boolean): SetLoadingAction {
  return {
    type: "SET_LOADING",
    payload: { isLoading },
  };
}

export function setSuccess(isSuccess: boolean): SetSuccessAction {
  return {
    type: "SET_SUCCESS",
    payload: { isSuccess },
  };
}

export function setFetching(isFetching: boolean): SetFetchingAction {
  return {
    type: "SET_FETCHING",
    payload: { isFetching },
  };
}

export function setInvoiceDetails(invoices: DataTableRow<T.PurchaseOrderInvoice>[]): setInvoicesAction {
  return {
    type: "SET_INVOICES",
    payload: { invoices },
  };
}

export function setInvoiceStats(invoiceStats: T.InvoiceStats): setInvoicesStatsAction {
  return {
    type: "SET_INVOICES_STATS",
    payload: { invoiceStats },
  };
}

export function reducer(state: PayoutState, action: PayoutActions): PayoutState {
  switch (action.type) {
    case "SET_INITIALIZED":
      return {
        ...state,
        isInitialized: action.payload.isInitialized,
      };
    case "SET_LOADING":
      return {
        ...state,
        isLoading: action.payload.isLoading,
      };
    case "SET_SUCCESS":
      return {
        ...state,
        isSuccess: action.payload.isSuccess,
      };
    case "SET_ERRORS":
      return {
        ...state,
        errors: action.payload.errors,
      };
    case "SET_INVOICES":
      return {
        ...state,
        invoices: action.payload.invoices,
      };
    case "SET_PAGINATION":
      return {
        ...state,
        pagination: action.payload.pagination,
      };
    case "SET_PARAMS":
      return {
        ...state,
        params: action.payload.params,
      };
    case "SET_FETCHING":
      return {
        ...state,
        isFetching: action.payload.isFetching,
      };
    case "SET_INVOICES_STATS":
      return {
        ...state,
        invoiceStats: action.payload.invoiceStats,
      };
    default:
      return state;
  }
}
